<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 商品名稱|SKU" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
					<!-- <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加系统公告</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button> -->

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="名稱|SKU" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索商品名稱|SKU"></el-input>
						</el-form-item>
						
						<el-form-item label="商戶">
							<el-select v-model="from.shop_id" multiple  clearable size="small" filterable placeholder="請選擇" style="width: 85%;">
								<!-- <el-option  label="全部" :value="-1"> -->
								</el-option>
								<el-option v-for="item in shop_list" :key="item.id" :label="item.name+'（'+item.username+')'" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="類型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="海外仓" :value="1"></el-option>
								<el-option label="中转仓" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="所在仓库" prop="go_id">
							<el-select v-model="from.go_id"  size="small" filterable placeholder="請選擇" style="width: 85%;">
								<el-option  label="全部" :value="-1">
								</el-option>
								<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
					
						
						
					
					

<!-- 
						<el-form-item label="時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item> -->

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange"  @expand-change="checkLog">
				
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				
				
				<!-- <el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column> -->
				
				
				<el-table-column type="expand" label="明细" width="80">
				  <template slot-scope="v">
					  <el-table
						:data="v.row.log"
						border
						 max-height	="450"
						style="width: 90%;margin-left: 5%;">
						
						
						
						<el-table-column width="180" align="center" prop="ins_name"  label="操作者"></el-table-column>
						<el-table-column align="center" width="600" prop="type_name"  label="操作詳情">
							<template slot-scope="k">
								<span>{{k.row.type_name}}</span>
								<span v-if="k.row.r_type==1">，備註：<span class="text-warning">{{k.row.remark}}</span></span>
								<span v-if="k.row.r_type==2">，转單號：<span @click="showExpress(k.row.remark)" class="text-blue text-a">{{k.row.remark}}</span></span>
								<span v-if="k.row.r_type==3">，快递單號：<span @click="showExpress(k.row.remark)" class="text-blue text-a">{{k.row.remark}}</span></span>

							</template>
						</el-table-column>
						<el-table-column width="120" align="center" prop="type_name"  label="操作數量">
							<template slot-scope="k">
								<span class="text-success" v-if="k.row.add==1">+ {{k.row.num}}</span>
								<span class="text-danger" v-if="k.row.add==0">- {{k.row.num}}</span>
							</template>
						</el-table-column>
						
						
						<el-table-column width="180" align="center" prop="create_time"  label="時間"></el-table-column>
						
						
						
					
					  </el-table>
					  							  
					  </el-tab-pane>
						
					</template>
				</el-table-column>
							
						
			
				
			
		
				
				<el-table-column align="center" prop="pro_name" label="商品名稱"></el-table-column>
				<el-table-column align="center" prop="sku" label="商品SKU"></el-table-column>
				<el-table-column align="center" prop="sp_name" width="150" label="对应商戶">
					<template slot-scope="v">
						<span>{{v.row.shop_name}}(<span class="text-danger">{{v.row.username}}</span>)</span>
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="go_name" label="所在仓库"></el-table-column>
				<el-table-column align="center" prop="go_type" label="仓库類型">
					<template slot-scope="v">
						<span v-if="v.row.go_type==1">海外仓</span>
						<span v-if="v.row.go_type==2">中转仓</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="num" label="當前库存"></el-table-column>
				
			
				
			
				
				
				
				
			<!-- 	
				<el-table-column align="center" width="150"  prop="status"  label="類型">
					<template slot-scope="v">
						<el-tag size="mini" v-if="v.row.type==1">系统通知</el-tag>
						<el-tag size="mini" v-if="v.row.type==2" type="success">後台公告</el-tag>
					</template>
				</el-table-column> -->
				
		
				
				
		
				
				
	
				
		
				
		
				
	
			
				
				
	
				
		
				
				
				
				
				<!-- <el-table-column align="center" prop="create_time" width="200" label="發送時間">
					
				</el-table-column>
				 -->
				

				
			
				
				

				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'添加系统公告':'修改系统公告'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
				
				<el-form-item label="發送類型"   prop="sendtype">
					
				
					 <el-radio v-model="form.sendtype" :disabled="editIndex>0?true:false" :label="0">全部</el-radio>
					 <el-radio v-model="form.sendtype" :disabled="editIndex>0?true:false" :label="1">指定店铺</el-radio>
					 <el-radio v-model="form.sendtype" :disabled="editIndex>0?true:false" :label="2">指定店長</el-radio>
				</el-form-item>
				
				<el-form-item v-show="form.sendtype==1" label="選擇店铺" prop="shop_id">
					<el-select v-model="form.shop_id" :disabled="editIndex>0?true:false"  size="small" filterable placeholder="請選擇" style="width: 85%;" >
						<el-option label="請選擇" disabled :value="0"></el-option>
						<el-option v-for="item in slist" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item v-show="form.sendtype==2" label="選擇店長" prop="sid">
					<el-select v-model="form.sid" :disabled="editIndex>0?true:false" size="small" filterable placeholder="請選擇" style="width: 85%;" >
						<el-option label="請選擇" disabled :value="0"></el-option>
						<el-option v-for="item in sadlist" :key="item.id" :label="item.name+'（ 店铺： '+item.shop_name+' )'" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item label="發送標題" prop="title">
					<el-input type="text" v-model="form.title" 
					placeholder="發送標題" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				
				
				
	
				
			
				
				<el-form-item label="發送内容" prop="content">
					<el-input type="textarea" :rows="8" v-model="form.content" 
					placeholder="發送内容" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				
		
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		


		<el-dialog :close-on-click-modal="false"  :title="lookData.type==1?'系统通知':'後台公告'" :visible.sync="lookModel"
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<div>
				<div class="text-center mb-2" style="font-size: 20px;">{{lookData.title}}</div>
				<div class="mb-3" style="text-align: right;color: #ccc;">{{lookData.time}}</div>
				<div class="px-5">{{lookData.content}}</div>
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="lookModel = false">关 闭</el-button>
				
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {
					title: [{
							required: true,
							message: "標題不能為空",
							trigger: 'blur',
						},
					],
					content: [{
							required: true,
							message: "内容不能為空",
							trigger: 'blur',
						},
					],
					
					
				},
				lookModel:false,
				lookData:{
					title:'',
					content:'',
					time:''
				},
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					shop_id:'',
					username:'',
					type:-1,
					go_id:-1,
					time: [],
				},
				model_title: 'Productnum',
				auth_val: 'Productnum',
				preUrl: "user/productnumList", //列表地址
				addUrl: "user/addNotice", //添加/修改地址
				delAllUrl: "user/delNoticeAll", //批量删除地址
				delUrl: "user/delNotice", //删除單条地址
				editStatusUrl: "user/editStatusNotice", //修改狀態地址
				tableData: [],
				form: {
					id: 0,
					title:'',
					content:"",
					sendtype:0,
					shop_id:0,
					sid:0
					
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				slist:[],
				sadlist:[],
				shop_list:[],
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			this.commonList('godownList');
		},
		methods: {
			checkNotice(e){
				e.is_read = 1
				
				this.layout.showNoticeModel(e)
				
				
				
			},
			
			checkLog(row,expandedRows){
				if(row.is_check_msg==0){
					this.checkLogApi(row)
					
				}
			},
			
			checkLogApi(row){
					this.axios.post('/admin/user/checkProductNumLog',
						{id:row.id}
					, {
						token: true,
					}).then(res => {
						let all = res.data
						if(all.code==1){
							row.is_check_msg = 1
							console.log(all.data)
							row.log = all.data.list.list
						}	
					}).catch(err => {
						// 失敗
						
					})
				
			},
			
			
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					
					let list = all.data.list
					this.rule_list = list.go_list
					this.shop_list = list.shop_list
					
			
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						
						if(this.form.sendtype==1 && !this.form.shop_id){
							this.$message.error('請選擇店铺');
							return false
						}
						if(this.form.sendtype==2 && !this.form.sid){
							this.$message.error('請選擇店長');
							return false
						}
					
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e, type) {
				console.log(e)
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						title: e.title,
						content: e.content,
						sendtype:e.sendtype,
						shop_id:e.shop_id,
						sid:e.sid,
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						title:'',
						content:"",
						sendtype:0,
						shop_id:0,
						sid:0
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					shop_id:'',
					username:'',
					type:-1,
					go_id:-1,
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
